// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepGeneralDescriptionContainer__ekWKP {
  max-height: 329px;
  overflow-y: auto;
  padding-right: 15px;
}
.stepGeneralDescriptionContainer__ekWKP::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.stepGeneralDescriptionContainer__ekWKP::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.stepGeneralDescriptionContainer__ekWKP::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.stepGeneralDescriptionContainer__ekWKP::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.attachesContainer__JHBDn {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.attaches__RByST {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.attachmentsLabel__yDoz3 {
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  padding-right: 17px;
}

.attachesBlock__Hb3Bo {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border: 1px dashed var(--buttons-surface);
  cursor: pointer;
}

.attachesLink__KBpdl {
  font-size: 14px;
  line-height: 12px;
  color: var(--buttons-surface);
  margin-left: 7px;
}

.uploadIcon__KHzS6 {
  stroke: --buttons-surface;
}

.attachesFiles__cGRrG {
  flex-grow: 1;
  align-items: flex-start;
  flex-wrap: nowrap;
  margin-top: 0;
  width: 100%;
}

.scrollingBlock__Prx79 {
  overflow-y: auto;
}
.scrollingBlock__Prx79::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.scrollingBlock__Prx79::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.scrollingBlock__Prx79::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.scrollingBlock__Prx79::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.attachBtnRight__OB8xV {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.uploadIconRight__Gw9M5 {
  width: 15px;
  stroke: var(--buttons-surface);
}

.uploadInstructionsText__A1Pby {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.uploadInstructionsText__A1Pby a {
  color: var(--buttons-surface);
  font-weight: 700;
  padding-left: 5px;
}

.uploadHintText___Ag8W {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/WarrantyModal/components/StepGeneralDescription/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AAzEF;AAsBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AApBJ;AAuBE;EACE,+BAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,8BAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,gBAAA;EACA,kBAAA;AAvBJ;;AA6DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA1DF;;AA6DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;EACA,mBAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;AA1DF;;AA6DA;EACE,yBAAA;AA1DF;;AA6DA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AA1DF;;AA6DA;EACE,gBAAA;AA1DF;AArDE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAuDJ;AApDE;EACE,+BAAA;EACA,kBAAA;AAsDJ;AAnDE;EACE,8BAAA;EACA,kBAAA;AAqDJ;AAlDE;EACE,gBAAA;EACA,kBAAA;AAoDJ;;AA8CA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA3CF;;AA8CA;EACE,WAAA;EACA,8BAAA;AA3CF;;AAgDA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7CF;AA+CE;EACE,6BAAA;EACA,gBAAA;EACA,iBAAA;AA7CJ;;AAiDA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA9CF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepGeneralDescriptionContainer {\n  max-height: 329px;\n  overflow-y: auto;\n  padding-right: 15px;\n\n  @include scrollBar;\n}\n\n.attachesContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.attaches {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.attachmentsLabel {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  padding-right: 17px;\n}\n\n.attachesBlock {\n  width: 100%;\n  height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n  border: 1px dashed var(--buttons-surface);\n  cursor: pointer;\n}\n\n.attachesLink {\n  font-size: 14px;\n  line-height: 12px;\n  color: var(--buttons-surface);\n  margin-left: 7px;\n}\n\n.uploadIcon {\n  stroke: (--buttons-surface);\n}\n\n.attachesFiles {\n  flex-grow: 1;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  margin-top: 0;\n  width: 100%;\n}\n\n.scrollingBlock {\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.attachBtnRight {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.uploadIconRight {\n  width: 15px;\n  stroke: var(--buttons-surface);\n}\n\n\n\n.uploadInstructionsText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n\n  a {\n    color: var(--buttons-surface);\n    font-weight: 700;\n    padding-left: 5px;\n  }\n}\n\n.uploadHintText {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepGeneralDescriptionContainer": `stepGeneralDescriptionContainer__ekWKP`,
	"attachesContainer": `attachesContainer__JHBDn`,
	"attaches": `attaches__RByST`,
	"attachmentsLabel": `attachmentsLabel__yDoz3`,
	"attachesBlock": `attachesBlock__Hb3Bo`,
	"attachesLink": `attachesLink__KBpdl`,
	"uploadIcon": `uploadIcon__KHzS6`,
	"attachesFiles": `attachesFiles__cGRrG`,
	"scrollingBlock": `scrollingBlock__Prx79`,
	"attachBtnRight": `attachBtnRight__OB8xV`,
	"uploadIconRight": `uploadIconRight__Gw9M5`,
	"uploadInstructionsText": `uploadInstructionsText__A1Pby`,
	"uploadHintText": `uploadHintText___Ag8W`
};
module.exports = ___CSS_LOADER_EXPORT___;
